import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="setting"
export default class extends Controller {
  static targets = [ 'allow', 'phone', 'email', 'fullname', 'address' ]
  connect() {
  }

  allowTargetConnected(ele) {
    console.log('----------------')
    console.log(ele)
    console.log('----------------')
  }
  phoneTargetConnected(ele) {
    console.log('----------------')
    console.log(ele)
    console.log('----------------')
  }
  emailTargetConnected(ele) {
    console.log('----------------')
    console.log(ele)
    console.log('----------------')
  }
  fullnameTargetConnected(ele) {
    console.log('----------------')
    console.log(ele)
    console.log('----------------')
  }
  addressTargetConnected(ele) {
    console.log('----------------')
    console.log(ele)
    console.log('----------------')
  }
  
  switchStatusOption(evt) {
    console.log('click')
    console.log(evt)
    console.log('----------------')
  }
}
